import { render, staticRenderFns } from "./SetupHolidays.vue?vue&type=template&id=20b84794"
import script from "./SetupHolidays.vue?vue&type=script&lang=js"
export * from "./SetupHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports